import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=067dd2c9&scoped=true&"
import script from "./subscription.vue?vue&type=script&lang=js&"
export * from "./subscription.vue?vue&type=script&lang=js&"
import style0 from "./subscription.vue?vue&type=style&index=0&id=067dd2c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dd2c9",
  null
  
)

export default component.exports